import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, ProductPriceListConversion, TmsWebBaseEditService } from 'tms-lib';
import { UnitOfMeasure } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class UnitOfMeasureService extends TmsWebBaseEditService<UnitOfMeasure, UnitOfMeasure> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('UnitOfMeasure', $localize`Unit of Measure`, httpService, notificationService);
  }

  checkAlternateUnitOfMeasure(
    id: string,
    productTypeId: string,
    unitOfMeasureId: string,
  ): Observable<ProductPriceListConversion> {
    return this.httpService.get<ProductPriceListConversion>(
      `${this.apiUrl}/CheckAlternateUnitOfMeasure?purchaseContractLineId=${id}&productTypeId=${productTypeId}&unitOfMeasureId=${unitOfMeasureId}`,
    );
  }
}
